import { DataCardinalities, DataTypes } from "../../../data/DataManager";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { EMPTY_VALUE, FieldSchema, FieldValueArray, FieldValueObject } from "../../../Schema";


export interface InstalledTestValue extends FieldValueObject {
  name: string;
  version: string;
}

export const installedTests: FieldSchema = {
  grid: {
    displayed: true,
    order: 29,
    filter: GridFilterTypes.NUMBER,
    integerOnly: true,
  },
  name: "installedTests",
  graphql: { selection: "installedTests { name version }" },
  dataTransform: {
    fromGraphql: {
      getter: (values): FieldValueArray | typeof EMPTY_VALUE => {
        const value = (values.installedTests as InstalledTestValue[]) || EMPTY_VALUE;
        if (value) {
          return value.map((test) => ({ name: test.name, version: test.version }));
        }
        return EMPTY_VALUE;
      },
    },
  },
  data: {
    type: DataTypes.OBJECT,
    cardinality: DataCardinalities.MULTIPLE,
  },
  display: {
    displayed: true,
  },
  form: { label: "Installed tests" },
};
